module.exports = __webpack_public_path__ + "media/images/workplace/banners/more_to_do/more_to_do_payout_card-0bf9852649c08b96b0da3f7295b9ab06.jpg";